import React, { useState } from 'react'
import dayjs from 'dayjs'
import duration from 'dayjs/plugin/duration'
import Icon from '@forwardflow/ui/Icons'
import { Avatar, message } from 'antd'
import useAuthUser from '@forwardflow/hooks/customHooks/useAuthUser'
import { getPlatformType } from '@forwardflow/helpers/utils'

dayjs.extend(duration)

interface MessageItemProps {
   item: any
}

export const AppointmentScheduledItem: React.FC<MessageItemProps> = ({
   item,
}) => {
   const { data: user } = useAuthUser({ revalidateOnMount: true })
   const [isDescriptionExpanded, setIsDescriptionExpanded] = useState(false)
   const handleCopy = () => {
      navigator.clipboard.writeText(item?.stepId).then(() => {
         message.success('Copied to clipboard')
      })
   }

   const toggleDescription = () => {
      setIsDescriptionExpanded(!isDescriptionExpanded)
   }

   const description = item?.appointment?.description || item?.description
   const shouldShowToggle = description && description.length > 100

   return (
      <div className="flex flex-col items-end justify-end gap-x-2">
         <div className="flex items-center justify-between bg-[#594180] py-4 px-8 w-full gap-y-4 text-[14px]">
            <div className="flex flex-col">
               {user?.email === 'operator@forward-flow.com' && item?.stepId && (
                  <div className="text-[11px] text-white/70 px-0 pb-3 flex gap-x-4">
                     <span
                        className="cursor-pointer select-all"
                        title="Click to copy"
                        onClick={handleCopy}
                     >
                        Step Id:{' '}
                        <span className="text-[12px] font-medium">
                           {item?.stepId}
                        </span>
                     </span>
                     {item?.campaignPhase && (
                        <span>
                           Phase:{' '}
                           <span className="text-[12px] font-medium">
                              {item?.campaignPhase}
                           </span>
                        </span>
                     )}
                     {item?.campaignType && (
                        <span>
                           Type:{' '}
                           <span className="text-[12px] font-medium">
                              {item?.campaignType}
                           </span>
                        </span>
                     )}
                  </div>
               )}
               <div className="flex items-center gap-x-4">
                  <Icon name="Calendar" className="fill-white" />
                  <p className="font-medium">Appointment Scheduled</p>
               </div>
            </div>
            <p className="text-[12px]">
               {dayjs(item?.ts).format('h:mm A, D MMM YYYY')}
            </p>
         </div>
         <div className="flex gap-3 bg-[#473466] w-full py-5 pl-8 pr-11 items-center cursor-pointer">
            <div className="px-4 py-2 rounded-[4px] flexc gap-x-3 bg-black/20">
               <p className="text-[12px] border-r pr-3">
                  {dayjs(item?.appointment?.date).format('h:mm A, D MMM YYYY')}
               </p>
               <p>{getPlatformType(item?.appointment?.platform)}</p>
            </div>
            <div className="flex flex-wrap items-center gap-3">
               {item?.invitees?.map((data: any, index: any) => {
                  return (
                     <div key={index}>
                        <div className="pr-5 rounded-full flexc bg-black/20">
                           <p className="text-[12px] font-medium pr-2">
                              <Avatar
                                 src={data?.avatar}
                                 className="w-9 h-9 bg-[#851E58]"
                              >
                                 {data?.name.slice(0, 1) || 'A'}
                              </Avatar>
                           </p>
                           <p className="text-[12px] font-medium">
                              {data?.name}
                           </p>
                        </div>
                     </div>
                  )
               })}
            </div>
         </div>
         {description && (
            <div className="bg-[#3d2a54] w-full px-8 py-4">
               <div className="flex items-start gap-x-3">
                  <div className="flex-1">
                     <div
                        onClick={toggleDescription}
                        className="text-[12px] text-white/80 leading-relaxed flex justify-between"
                     >
                        {shouldShowToggle ? (
                           <>
                              <p
                                 className={`transition-all duration-300 ${
                                    isDescriptionExpanded ? '' : 'line-clamp-3'
                                 }`}
                              >
                                 {description}
                              </p>
                              <button
                                 className={`flex items-center justify-center w-6 h-6 mt-2 text-blue-300 transition-colors rounded-full hover:text-blue-200 hover:bg-blue-300/10 ${
                                    isDescriptionExpanded ? 'rotate-180' : ''
                                 }`}
                              >
                                 <Icon
                                    name={'arrow-down'}
                                    className={`fill-white `}
                                 />
                              </button>
                           </>
                        ) : (
                           <p>{description}</p>
                        )}
                     </div>
                  </div>
               </div>
            </div>
         )}
      </div>
   )
}
